type PumpingStateListener = () => void

const listeners = new Set<PumpingStateListener>()
let pumping = false

function notifyPumpingStateChange (): void {
  for (const listener of listeners) {
    listener()
  }
}

export const pumpingState = {
  get pumping (): boolean {
    return pumping
  },
  set pumping (value: boolean) {
    if (pumping === value) {
      return
    }
    pumping = value
    notifyPumpingStateChange()
  },
}

export function onPumpingStateChange (listener: PumpingStateListener): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
